class StockIndicator extends HTMLElement {
  connectedCallback() {
    this.formatQuantities();

    this.onVariantChange = (event) => {
      this.render(Number(event?.detail?.variant?.id));
    };
    document.addEventListener('variant-change', this.onVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('variant-change', this.onVariantChange);
  }

  formatQuantities() {
    this.querySelectorAll('[data-stock-indicator]')?.forEach((stockVariant) => {
      const quantityEl = stockVariant.querySelector('[data-stock-quantity-display]');
      if (!quantityEl) return;

      const quantity = Number(stockVariant.dataset.stockQuantity);
      quantityEl.innerHTML = quantityEl.innerHTML.replace(
        quantity,
        quantity.toLocaleString()
      );
    });
  }

  render(selectedVariantId) {
    if (typeof selectedVariantId !== 'number') return;

    this.querySelectorAll('[data-stock-indicator]')?.forEach((stockVariant) => {
      Number(stockVariant.dataset.stockIndicator) === selectedVariantId
        ? stockVariant.classList.remove('hidden')
        : stockVariant.classList.add('hidden');
    });
  }
}

// Define the custom element
customElements.define('stock-indicator', StockIndicator);
